var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html(response.msg);
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

$(document).ready(function () {
  var elements = document.querySelectorAll('.js-gallery');
  if(elements && elements.length>0){
    for(var i=0;i<elements.length;i++){
        $(".js-gallery").eq(i).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Ładowanie #%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: 'Zamknij',
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: 'Poprzednie',
                tNext: 'Następne',
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
            },
            image: {
                tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    }
  }
});

$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {
    var el = $('[data-cookies]');

    $('[data-closecookies]').on('click', function () {
        el.fadeOut();
        Cookies.set('cookies_info', '1', {expires: 12});
    });

    var myCookie = Cookies.get('cookies_info');
    if (myCookie === undefined) {
        el.show();
    }
});
$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
    }
  });
  

  $("[data-menu]:not(.actived)").on("click", function (e) {
    if( $(this).hasClass('actived')) { 
      window.location.href = $(this).attr('href');
    } else {
      e.preventDefault();
      var el = $(this);
      el.addClass("actived");
      el.next('ul').addClass("opened");
      $('.mobileMenu__tools').append("<a class='js-prev mobilePrev'></a>");
    }
    
  });

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});

// main slider
var $slider =  $('.js-slider');
function myHandler() {
  $slider.slick('slickPlay');
}
function playVideoSlide(slick,currentSlide,mute){

  var slide = $(slick.$slides.get(currentSlide));
  if(slide.find('video').length){
    if(slide.find('video')[0].readyState >= 2) {

      if(typeof mute !=="undefined")
        slide.find('video')[0].muted = true;
      else
        slide.find('video')[0].muted = false;

      slide.find('video')[0].play();
      $slider.slick('slickPause');

    } else {
      slide.find('video')[0].oncanplay = function() {
        if(typeof mute !=="undefined")
          slide.find('video')[0].muted = true;
        else
          slide.find('video')[0].muted = false;
        slide.find('video')[0].play();
        $slider.slick('slickPause');
      }
    }

    slide.find('video')[0].addEventListener('ended',function() {
      myHandler;
      $slider.slick('slickNext');
    },false);
  }
}

$slider.on('init reInit', function(event, slick) {
  $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
  $('.js-slider .slick-current').addClass('slider__item--visible');
  playVideoSlide(slick,0,1);
});
$slider.on('afterChange', function(event, slick, currentSlide) {
  var slide = $(slick.$slides.get(currentSlide));
  $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
  $('.js-slider .slick-current').addClass('slider__item--visible');
  playVideoSlide(slick,currentSlide,1);

  if(!slide.find('video').length){
    $slider.slick('slickPlay');
  }
});
$slider.on('beforeChange', function(event, slick, currentSlide,nextSlide) {
  var slide = $(slick.$slides.get(currentSlide));
  if(slide.find('video').length){
    slide.find('video')[0].pause();
  }
});

$slider.slick({
  arrows: true,
  speed: 700,
  autoplaySpeed: 7000,
  dots: true,
  infinite: true,
  autoplay: true,
  vertical: true,
  verticalSwiping: true,
  slidesToScroll: 1
  // adaptiveHeight: true -> for videos
});

$(".slider__textItem--2").lettering('words');

//slider--3 dots
if ( $('.js-slider--3').length ) {
    $('.js-slider--3 .slick-dots button').each(function(i) {
        i++;
        n=i;
        $(this).attr('data-number',++i).append('<span>0'+ n +'</span>');
    });
}
 // imageslider
 var elements = document.querySelectorAll('.js-sliderGallery');
 if ( elements.length>0){
   $('.js-sliderGallery').slick({
       arrows: true,
       speed: 700,
       autoplaySpeed: 7000,
       dots: true,
       infinite: true,
       autoplay: true,
       slidesPerRow: 5,
       rows: 2,
       responsive: [
         {
           breakpoint: 678,
           settings: {
             slidesPerRow: 2,
             rows: 2,
           }
         }
       ]
   });
 }
// scrolledGallery for mobiles
let scrolledGallery = function() {
    $('.js-scrolledGallery').slick({
        arrows: true,
        speed: 700,
        fade: true,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              dots: false
            }
          }
        ]
    });
}
if ($(window).width() < 600) {
    scrolledGallery();
}
$(window).on('resize', function(){
    if ($(window).width() < 600) {
        scrolledGallery();
    }
});
//offerSlider
var element = document.querySelector('.js-offerSlider');
if ( $('.js-offerSlider').length ){
  $('.js-offerSlider').slick({
      arrows: true,
      speed: 1400,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 800,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              fade: false
          }
        },
        {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              fade: true
          }
        }
      ]
  });
}

//logoSlider
if ( $('.js-logoSlider').length ){
  $('.js-logoSlider').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 900,
          adaptiveHeight: false,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
        }
        ,
        {
          breakpoint: 600,
          adaptiveHeight: true,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }
      ]
  });
}
//productSlider
if ( $('.js-productSlider').length ) {
  $('.js-productSlider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      infinite: true,
      autoplay: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider-nav-thumbnails',
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
  $('.slider-nav-thumbnails').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.js-productSlider',
    dots: true,
    focusOnSelect: true
  });
}

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
$(document).ready(function(){

  // go to form message
  if ( $('.formErrors__item').length ) {
    $('html, body').animate({
        scrollTop:  $('.formErrors__item').first().offset().top - 200
    }, 600);
  }

  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');
        $('.languageBox__select').toggleClass('active');
        return false;
    });
  }
  
  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500,
          disable: 'mobile'
      });
  }

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad(); 
    observer.observe();
  }
  
  // scrolled menu
  if ($(window).width()<1240){
          $('.js-header').addClass('header--scrolled');
  } else {
      $('.js-header').removeClass('header--scrolled');
  }

  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        center: true
        // wrapper: '.rellax-parent',
        // relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  //go to form
  if ($('.js-gotoform').length) {
    $('.js-gotoform').on('click', function(){
        let anchor = $('.footer__form');
        if (anchor.length) {
            $('html, body').animate({
                scrollTop:  $(anchor).offset().top
            }, 600);
            return false;
        }
    });
  }
  
  //go to comment form
  if ($('.js-comments__addButton').length) {
    $('.js-comments__addButton').on('click', function(){
      let anchor = $('#commentForm');
      $('html, body').animate({
          scrollTop:  $(anchor).offset().top - 100
      }, 600);
      return false;
    });
  }

  //go to map
  if ($('.js-gotomap').length) {
    $('.js-gotomap').on('click', function(){
        let anchor = $('.contact__map');
        if (anchor.length) {
            $('html, body').animate({
                scrollTop:  $(anchor).offset().top - 100
            }, 600);
            return false;
        }
    });
  }

  // scrolled menu
  if ($(window).scrollTop() > 0) {
    $('.js-header').addClass('header--scrolled');
    if ($('.hamburger--2').length) {
      $('.hamburger--2').on("click", function () {
        //$(this).toggleClass('active');
        $('.header--3').removeClass('header--scrolled');
      });
    }
  } else {
    if ( $(window).width()>1240 && $('.hamburger--2').length==0 ){
      $('.js-header').removeClass('header--scrolled');
    }
  }

  //search
  $('.js-header__search').on('click', function(){
      $('.header .header__searchBox form').toggleClass('header__searchBoxForm--hidden');
      $('.header .header__searchBox').slideToggle(300);
  });
  $('.js-header__searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });


  //filters in offer
  if ($("[data-filter-submit]").length) {
    $("[data-filter-submit]").click(function(){
      var filters = $("[data-filter]"),name,value,counter=1,type;
      var url = top.location.href.split(",");
      var checkedFilters = new Array();
      url = url[0]+",1&";
      for(var i=0;i<filters.length;i++){
        id = filters.eq(i).attr('data-filter');
        name = filters.eq(i).attr('data-filter-field');
        type = filters.eq(i).attr('type');
  
        if($.inArray(id,checkedFilters)===-1){
          value = "";
          if($("[data-filter='"+id+"']").length>1){
            var subFilters = $("[data-filter-field='"+name+"']");
            for(var j=0;j<subFilters.length;j++){
              if(type=="checkbox"){
                value+= subFilters.eq(j).is(":checked") ? subFilters.eq(j).val()+"," : "";
              }else if(subFilters.eq(j).val()!=""){
                value+= subFilters.eq(j).val()+",";
              }
            }
            if(value[value.length-1] == ","){
              value = value.slice(0,-1);
            }
          }else if(type=="checkbox"){
            value = filters.eq(i).is(":checked") ? filters.eq(i).val() : "";
          }else{
            value = filters.eq(i).val();
          }
  
          if(typeof value!=="undefined" && value!="" && value!=","){
            if(typeof filters.eq(i).attr('data-filter-name')==="undefined"){
              url+= "filter_" + counter + "=" + name + "&value_" + counter + "=" + value;
              if(typeof filters.eq(i).attr('data-filter-operator')!=="undefined"){
                url+= "&operator_" + counter + "=" + filters.eq(i).attr('data-filter-operator');
              }
              url+="&";
              counter++;
            }else{
              url+= filters.eq(i).attr('data-filter-name') + "=" + value+"&";
            }
          }
  
          checkedFilters.push(name);
        }
      }
      if($("[data-filter-sort]").find("option:selected").val()!=""){
        url+= "sort="+$("[data-filter-sort]").find("option:selected").val()+"&";
        url+= "sort_order="+$("[data-filter-sort]").find("option:selected").attr('data-sort-order')+"&";
      }
  
      if(url[url.length-1] == "&"){
        url = url.slice(0,-1);
      }
      top.location.href = url;
    });
  
    $("[data-filter-sort]").change(function(){
      $("[data-filter-submit]").trigger('click');
    });
  
    $("[data-filter-clear]").click(function(){
      var url = top.location.href.split(",");
      top.location.href = url[0];
    });
  }

  // sticky
  if ( $('.sidebarMenu > div').length && ( $(window).width() > 1024 ) && ( $('.main__modules').height() >= $('.main__sidebar div[data-sticky-class]').height()) )  {
    let sticky = new Sticky('.sidebarMenu > div');
  }

  // file input
  if ( $('.styledFormItems--file').length) {
    let pullfiles = function(){
      let fileInput = document.querySelector(".styledFormItems--file input");
      let filesContainer = document.querySelector('.styledForm__files');
      let files = fileInput.files;
      let fl = files.length;
      let i = 0;
      while ( i < fl) {
          let file = files[i];
          let element = document.createElement("span");
          element.appendChild(document.createTextNode(file.name));
          filesContainer.appendChild(element);
          i++;
      }
    }  

    document.querySelector(".styledFormItems--file input").onchange = pullfiles;

    $(document).on('click','.styledForm__files span', function(){
      // var newFileList = $(".styledFormItems--file input").prop("files");
      $(this).remove();
    });
  }

  $(window).on('mousemove', function(e) {
    var w = $(window).width();
    var h = $(window).height();
    var offsetX = 0.5 - e.pageX / w;
    var offsetY = 0.5 - e.pageY / h;

    $(".parallaxImg").each(function(i, el) {
      var offset = parseInt($(el).data('offset'));
      var translate = "translate3d(" + Math.round(offsetX * offset) + "px," + Math.round(offsetY * offset) + "px, 0px)";

      $(el).css({
        '-webkit-transform': translate,
        'transform': translate,
        'moz-transform': translate
      });
    });
  });
  
}); // end document ready

$(window).on('load', function(){

});

$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 } else {
  if ($(window).width()>1240){
    $('.js-header').removeClass('header--scrolled');
  }
}

}); // end onscroll

var validator = new function() {
    this.methods = function() {
        jQuery.validator.addMethod("phone", function(value, element) {
            var slug = /^[0-9\-]+$/;
            return slug.test(value) && value.length == 9;
        }, Laravel.lang.validation.phone);
    };
};

$(document).ready(function() {
    validator.methods();

    $("[data-search-form] input").bind("keyup",function(){
      var value = $(this).val();

      if(value.length>2){
        var currentRequest = null;

        currentRequest = jQuery.ajax({
            type: 'POST',
            data: {
              'phrase':value,
              '_token': window.Laravel.csrfToken,
              'lang': $('html').attr('lang')
            },
            url: '/module/search/hint',
            beforeSend : function()    {
                if(currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function(data) {
                $("[data-search-form] ul").html('');
                if(Object.keys(data.results).length>0){
                  for (var prop in data.results) {
                    // for(var item in data.results[prop]){
                      var template = $("#search-hint-template").html();
                      var stone = Handlebars.compile(template)({"results":data.results[prop]});
                      var items = $.parseHTML(stone);
                      // console.log(data.results);
                      // console.log(Laravel.lang.search);
                      $("[data-search-hintcontainer]").append("<li><h2>"+Laravel.lang.search[prop]+"</h2></li>");
                      $("[data-search-hintcontainer]").append(items);
                    // }
                    $("[data-search-hintcontainer]").addClass('visible');
                  }
                }else{
                  $("[data-search-hintcontainer]").removeClass('visible')
                }
            },
            error:function(e){
              // Error
            }
        });
      }else{
        $("[data-search-hintcontainer]").removeClass('visible')
      }
    });
});

//# sourceMappingURL=front.js.map
